export default "__VITE_ASSET__BXaYLAfG__"